module.exports = __webpack_public_path__ + "img/1c.194da54f.svg";